import React from "react";
import ReactLoading from "react-loading";
import { useGlobalLoading } from "@/hooks/useGlobalLoading";

const GlobalLoader = () => {
  const isLoading = useGlobalLoading();

  if (!isLoading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "transparent",
        zIndex: 30000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ReactLoading
        type="spinningBubbles"
        color="#000000"
        className="loading"
        height={32}
        width={32}
      />
    </div>
  );
};

export default GlobalLoader;
